import connection from 'connection';
import {normalizeLanguage} from '../utils';

export const recoverPassword = async email =>
   connection.post('v1/auth/password', {email, redirect_url: `${process.env.REACT_APP_HOME}/login`});

export const registerUser = async (email, name, password, phoneNumber, language) =>
   connection.post('v1/auth', {email, name, password, phone_number: phoneNumber, language: normalizeLanguage(language), confirm_success_url: process.env.REACT_APP_HOME});

export const updateUserAccount = async (values, language) =>
   connection.put('v1/auth', values, {params: {locale: normalizeLanguage(language)}});

export const deleteUserAccount = async password =>
   connection.delete('v1/auth', { data: { password: password } });

export const updatePartner = async (values, originalEnrollmentId) =>
   connection.post(`v1/current_user/enrollments/${originalEnrollmentId}/change_partner`, values);

export const replaceOriginalPartner = async enrollment =>
   connection.post(`v1/current_user/enrollments/${enrollment.id}/resubstitute_original_partner.json`);

export const sendFirebaseToken = async (firebaseToken) =>
    connection.post('v1/current_user/save_firebase_token', {firebase_token: firebaseToken});

export const getUserPhoto = async =>
   connection.get('v1/enrollments/get_user_photo');

export const updateUserPhoto = async photo =>
   connection.post('v1/current_user/update_user_photo', photo);
